import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, HeartIcon, ChevronDownIcon } from 'lucide-react';
type Comment = {
  id: string;
  name: string;
  location: string;
  text: string;
  date: string;
  rating: number;
  likes: number;
  isLiked: boolean;
  avatarColor: string;
};
const initialComments: Comment[] = [{
  id: 1,
  name: 'Carlos Rodríguez',
  location: 'Buenos Aires, AR',
  text: 'Increíble el nivel de detalle. Nunca pensé que podría hacer un cartel de neón desde cero, pero el paso a paso es súper claro. ¡Ya vendí mi primer diseño!',
  rating: 5,
  likes: 124,
  isLiked: false,
  avatarColor: '#3b82f6',
  date: 'Hace 2 días'
}, {
  id: 2,
  name: 'Lucía Méndez',
  location: 'Santiago, CL',
  text: 'Los secretos de soldadura valen oro. Me ahorré muchísimos materiales que antes desperdiciaba por no saber la técnica correcta. Muy recomendado.',
  rating: 5,
  likes: 89,
  isLiked: false,
  avatarColor: '#10b981',
  date: 'Hace 1 semana'
}, {
  id: 3,
  name: 'Martín Sosa',
  location: 'Montevideo, UY',
  text: 'Excelente inversión. El módulo de costos me ayudó a cobrar lo que realmente vale mi trabajo. Ya recuperé el valor del curso con mi primera venta.',
  rating: 5,
  likes: 56,
  isLiked: false,
  avatarColor: '#f59e0b',
  date: 'Hace 3 días'
}, {
  id: 4,
  name: 'Elena Gómez',
  location: 'Córdoba, AR',
  text: 'Muy completo. Las plantillas de diseño me facilitaron todo el proceso creativo. Los videos son cortos y van directo al grano.',
  rating: 4,
  likes: 42,
  isLiked: false,
  avatarColor: '#ec4899',
  date: 'Hace 5 días'
}, {
  id: 5,
  name: 'Javier López',
  location: 'Mendoza, AR',
  text: 'Lo mejor es el soporte. Tuve una duda con la fuente de alimentación y me respondieron enseguida. El material es de primera calidad.',
  rating: 5,
  likes: 31,
  isLiked: false,
  avatarColor: '#8b5cf6',
  date: 'Hace 2 semanas'
}, {
  id: 6,
  name: 'Sofía Castro',
  location: 'Rosario, AR',
  text: '¡Por fin un curso que explica bien el cableado invisible! Mis carteles ahora parecen comprados en una tienda de lujo.',
  rating: 5,
  likes: 67,
  isLiked: false,
  avatarColor: '#ef4444',
  date: 'Hace 4 días'
}, {
  id: 7,
  name: 'Andrés Villa',
  location: 'Bogotá, CO',
  text: 'Empecé como hobby y ahora tengo pedidos todas las semanas. La guía de proveedores locales es súper útil.',
  rating: 5,
  likes: 45,
  isLiked: false,
  avatarColor: '#06b6d4',
  date: 'Hace 6 días'
}, {
  id: 8,
  name: 'Valeria Ortiz',
  location: 'Lima, PE',
  text: 'Me encantó la parte de los espejos infinitos. Es un efecto que a mis clientes les vuela la cabeza. Gracias por compartir tanto.',
  rating: 5,
  likes: 92,
  isLiked: false,
  avatarColor: '#f97316',
  date: 'Hace 1 día'
}, {
  id: 9,
  name: 'Ricardo Paz',
  location: 'Salta, AR',
  text: 'La técnica de pegado que enseñan es impecable. Antes se me despegaban las tiras, ahora quedan perfectas.',
  rating: 5,
  likes: 28,
  isLiked: false,
  avatarColor: '#14b8a6',
  date: 'Hace 10 días'
}, {
  id: 10,
  name: 'Mariana Silva',
  location: 'Asunción, PY',
  text: 'Un curso muy profesional. Se nota que saben de lo que hablan. Los planos con medidas me ahorraron horas de dibujo.',
  rating: 5,
  likes: 53,
  isLiked: false,
  avatarColor: '#6366f1',
  date: 'Hace 12 días'
}, {
  id: 11,
  name: 'Gabriel Ruiz',
  location: 'Neuquén, AR',
  text: 'Increíble cómo explican la parte eléctrica. Yo no sabía nada y ahora armo mis propias conexiones sin miedo.',
  rating: 5,
  likes: 37,
  isLiked: false,
  avatarColor: '#a855f7',
  date: 'Hace 8 días'
}, {
  id: 12,
  name: 'Camila Torres',
  location: 'San Juan, AR',
  text: 'El pack de bonos es genial. Las tipografías que incluyen son justo lo que necesitaba para mis diseños modernos.',
  rating: 5,
  likes: 19,
  isLiked: false,
  avatarColor: '#fbbf24',
  date: 'Hace 9 días'
}, {
  id: 13,
  name: 'Ignacio Vera',
  location: 'La Plata, AR',
  text: 'Muy buena relación calidad-precio. He pagado cursos más caros que no enseñan ni la mitad de lo que hay acá.',
  rating: 4,
  likes: 24,
  isLiked: false,
  avatarColor: '#4ade80',
  date: 'Hace 11 días'
}, {
  id: 14,
  name: 'Paula Domínguez',
  location: 'Tucumán, AR',
  text: 'Gracias a este curso pude armar el cartel para el cumple de 15 de mi hija y quedó espectacular. ¡Todos me preguntaban dónde lo compré!',
  rating: 5,
  likes: 71,
  isLiked: false,
  avatarColor: '#fb7185',
  date: 'Hace 13 días'
}, {
  id: 15,
  name: 'Fernando Costa',
  location: 'Mar del Plata, AR',
  text: 'Excelente material. Muy didáctico y fácil de seguir. Lo recomiendo para cualquiera que quiera emprender.',
  rating: 5,
  likes: 15,
  isLiked: false,
  avatarColor: '#2dd4bf',
  date: 'Hace 14 días'
}];
export function CommentsSection() {
  const [comments, setComments] = useState<Comment[]>(initialComments);
  const [visibleCount, setVisibleCount] = useState(5);
  const toggleLike = (id: number) => {
    setComments(prev => prev.map(c => c.id === id ? {
      ...c,
      likes: c.isLiked ? c.likes - 1 : c.likes + 1,
      isLiked: !c.isLiked
    } : c));
  };
  return <section className="py-12 px-4 bg-transparent relative z-10" data-id="element-121">
      <div className="max-w-3xl mx-auto" data-id="element-122">
        <div className="text-center mb-8" data-id="element-123">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-124">
            Comentarios de Alumnos
          </motion.h2>
          <div className="flex items-center justify-center gap-2 text-green-400 font-bold text-sm" data-id="element-125">
            <div className="flex gap-0.5" data-id="element-126">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-127" />)}
            </div>
            <span data-id="element-128">4.9/5 basado en +2,000 alumnos</span>
          </div>
        </div>

        <div className="space-y-3" data-id="element-129">
          {comments.slice(0, visibleCount).map((comment, i) => <motion.div key={comment.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: Math.min(i * 0.05, 0.3)
        }} className="bg-[#d1fae5] border border-green-200 rounded-xl p-4 hover:border-green-300 transition-all shadow-sm" data-id="element-130">
              <div className="flex items-start gap-3" data-id="element-131">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-black text-base shrink-0 shadow-md" style={{
              backgroundColor: comment.avatarColor
            }} data-id="element-132">
                  {comment.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0" data-id="element-133">
                  <div className="flex items-center justify-between gap-3 mb-0.5 flex-wrap" data-id="element-134">
                    <div data-id="element-135">
                      <h4 className="font-bold text-gray-900 text-sm md:text-base" data-id="element-136">
                        {comment.name}{' '}
                        <span className="text-green-700/70 font-medium text-xs" data-id="element-137">
                          · {comment.location}
                        </span>
                      </h4>
                      <div className="flex items-center gap-2 mt-0.5" data-id="element-138">
                        <div className="flex gap-0.5" data-id="element-139">
                          {[...Array(5)].map((_, idx) => <StarIcon key={idx} className={`w-3 h-3 ${idx < comment.rating ? 'fill-[#f5c518] text-[#f5c518]' : 'text-gray-300'}`} data-id="element-140" />)}
                        </div>
                        <span className="text-[10px] text-green-700/60" data-id="element-141">
                          {comment.date}
                        </span>
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-800 text-sm leading-snug mt-1.5" data-id="element-142">
                    {comment.text}
                  </p>
                  <button onClick={() => toggleLike(comment.id)} className={`mt-2 inline-flex items-center gap-1 text-xs font-bold transition-colors ${comment.isLiked ? 'text-[#ec4899]' : 'text-gray-500 hover:text-[#ec4899]'}`} data-id="element-143">
                    <HeartIcon className={`w-3.5 h-3.5 ${comment.isLiked ? 'fill-current' : ''}`} data-id="element-144" />
                    {comment.likes}
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>

        {visibleCount < comments.length && <div className="mt-8 text-center" data-id="element-145">
            <button onClick={() => setVisibleCount(prev => prev + 5)} className="inline-flex items-center gap-2 px-8 py-3 bg-white/10 hover:bg-white/20 border border-white/20 rounded-full text-white font-bold transition-all group" data-id="element-146">
              Ver más comentarios
              <ChevronDownIcon className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" data-id="element-147" />
            </button>
          </div>}
      </div>
    </section>;
}